var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShape1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 111,
  height: 63,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#shape-1_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F8F3F4",
  d: "M80.8 37.5 58.7 25.8 0 63h110.8l-25-63z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "shape-1_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h110.8v63H0z"
})))));
export { SvgShape1 as ReactComponent };
export default __webpack_public_path__ + "static/media/shape-1.e9843383e18f6e4c36ad.svg";